import {useLayoutEffect, useState} from "react";
import {getItem, getUrl, mergeDeep, upTimer} from "./lib";
import {setProfile, setRegister, setStep, setTrack, setTrackStep, trackContent} from "./tracking";
import {useTranslation} from "react-i18next";
import {LandingEnum, SurveyEnum} from "_business";
import {useNavigate} from "react-router-dom";
import {ReactComponent as IconNo} from "assets/img/icon/no.svg";
import {ReactComponent as IconYes} from "assets/img/icon/yes.svg";


const MonthEnum = Object.freeze({
  ru: [
    'январю',
    'февралю',
    'марту',
    'апрелю',
    'маю',
    'июню',
    'июлю',
    'августу',
    'сентябрю',
    'октябрю',
    'ноябрю',
    'декабрю',
  ],
  // uk: [
  //   'січню',
  //   'лютому',
  //   'березню',
  //   'квітню',
  //   'травню',
  //   'червню',
  //   'липню',
  //   'серпню',
  //   'вересню',
  //   'жовтню',
  //   'листопаду',
  //   'грудню',
  // ]
})

// const isExistImage = (imageName) => {
//   try {
//     require(`assets/${imageName}`)
//     return true
//   } catch (error) {
//     return false
//   }
// }

const getImage = (path) => {
  // try {
    // src/assets/img/survey/face/A49/img_morgan_freeman.svg
    // i18/img/survey/face/A49/img_morgan_freeman.svg
    // if (imageName.endsWith('.svg'))
    //   return require(`assets/${imageName}`).default
    // else

    if (process.env.REACT_APP_MODULE !== 'default')
      return `/${process.env.REACT_APP_MODULE}/static/${path}`
      // return `/static/${process.env.REACT_APP_MODULE}/${path}`

    // return require(`assets/${path}`)
    return `/static/${path}`
  // } catch (error) {
  //   console.error('Image not found', path)
  //   return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epMuBMAAAAASUVORK5CYII='
  // }
}


export const useSurvey = ({step, nextUrl} = {}) => {
  const
    {t, i18n} = useTranslation(),
    navigate = useNavigate(),

    surveyList = t('data', {ns: 'survey', returnObjects: true})
  // surveyList = t0('data', {ns: 'survey', returnObjects: true, lng: 'en'}), i18n.resolvedLanguage

  let hash = +window.location.hash.replace('#', '')

  if (!Number.isInteger(hash) || hash >= surveyList.length)
    hash = ''

  const
    [state, setState] = useState({
      index: (hash || 0),
      resultList: getItem('survey_results'),
      imageSize: {},
    }),

    s1 = surveyList.findIndex(({id}) => id === 'target1')

  const
    resGender =
      state.resultList?.[
        surveyList.findIndex(({id}) => id === 'gender')
      ],
    sex = +resGender?.[0] === 0 ? 'man' : 'woman'

  let sexId = 0

  switch (+resGender?.[0]) {
    case 0:
      sexId = 1
      break

    case 1:
      sexId = 2
      break
  }

  let g1 =
    window.landing.includes('masculinity')
      ? surveyList[s1].list.findIndex(({id, title}) => id === 'Masculinity' || title === 'Masculinity')
      : +state.resultList?.[s1]?.[0] || 0

  // if (A49.value === 'B' && [3, 4].includes(g1))
  //   g1 = 0

  const
    goal = surveyList[s1].list[g1] || surveyList[s1].list[0],
    goalId = goal ? (goal.id || goal.title).toLowerCase().replace(/ /g, '-') : ''

  const getSurveyByIndex = (index, survey) => {
    if (!survey)
      survey = {...surveyList[index]}

    if (survey?.switch) {
      const sIndex =
        survey.target
          ? surveyList.findIndex(item => item.id === survey.target)
          : index - 1
      let rIndex

      rIndex =
        window.landing.includes('masculinity') && survey.target === 'target1' && survey.id !== 'target2'
          ? g1
          : state.resultList[sIndex]?.[0]

      if (survey.targetIndex) {
        rIndex = survey.switch.findIndex(item => item.targetIndex === rIndex)

        if (rIndex < 0)
          rIndex = 0
      }

      const switchSurvey = () => {
        const {switch: _, ...newSurvey} = survey

        survey = mergeDeep(
          newSurvey,
          survey.switch[rIndex]
        )

        if (survey?.switch || Array.isArray(survey?.target))
          survey = getSurveyByIndex(index, survey)
      }

      switchSurvey()
    } else if (Array.isArray(survey?.target)) {
      for (const [i, target] of survey.target.entries()) {
        const
          si = surveyList.findIndex(item => item.id === target),
          sur = getSurveyByIndex(si)

        let res =
          window.landing.includes('masculinity') && target === 'target1'
            ? [g1]
            : state.resultList[si]

        if (res && sur && survey?.subheader) {
          let obj = sur.list[res[0]]?.subtitle || sur.list[res[0]]?.title;

          if (i && obj)
            obj = obj.toLowerCase()

          survey.subheader = survey.subheader.replace(`{obj${i + 1}}`, obj)
        }
      }

      let date = new Date();
      date.setMonth(date.getMonth() + 3)

      if (survey.random) {
        date.setDate(
          date.getDate() - 5 - Math.floor(Math.random() * 11)
        )
      }

      const day = date.getDate();
      // const month = date.toLocaleString("default", { month: "short" });
      // const year = date.getFullYear();

      const nthNumber = (number) => {
        return number > 0 && i18n.resolvedLanguage === 'en'
          ?
          ["th", "st", "nd", "rd"][
            (number > 3 && number < 21) || number % 10 > 3 ? 0 : number % 10
            ]
          : ""
      }

      // const dateString = date.toLocaleDateString('en-us', {weekday: "long", year: "numeric", month: "short", day: "numeric"});
      // const dateString = date.toLocaleDateString(i18n.resolvedLanguage, {month: "short", day: "numeric"}) + nthNumber(day);
      // const dateLongString = date.toLocaleDateString(i18n.resolvedLanguage, {month: "long", day: "numeric"});
      // const dateShortString = date.toLocaleDateString(i18n.resolvedLanguage, {month: "long"});

      // const formatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'short' });
      // const formatter = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
      // const dateString = formatter.format(date);

      // // const dateString = `${month} ${day}${nthNumber(day)}, ${year}`;
      // const dateString = `${month} ${day}${nthNumber(day)}`;

      // const s1 = surveyList.findIndex(({id}) => id === 'target1');
      //
      // if (surveyList[s1].list[+state.resultList?.[s1]?.[0] || 0]?.shortDate)
      //   survey.subheader = survey.subheader.replace('{date}', '{date-short}');

      const insertDate = (string) => {
        const map = {
          '{date}': date.toLocaleDateString(i18n.resolvedLanguage, {month: "short", day: "numeric"}) + nthNumber(day),
          '{date-long-nth}': date.toLocaleDateString(i18n.resolvedLanguage, {month: "long", day: "numeric"}) + nthNumber(day),
          '{date-long}': date.toLocaleDateString(i18n.resolvedLanguage, {month: "long", day: "numeric"}),
          '{date-short}': date.toLocaleDateString(i18n.resolvedLanguage, {month: "long"}),
        }

        if (MonthEnum[i18n.resolvedLanguage])
          map['{date-short-1}'] = MonthEnum[i18n.resolvedLanguage][date.getMonth()]
        else
          map['{date-short-1}'] = map['{date-long}'].split(' ')[1]

        return string.replace(/\{date(-long|-short|-short-1|-long-nth)?\}/g, function(m) { return map[m] })
      }

      if (survey.subheader)
        survey.subheader = insertDate(survey.subheader)

      if (survey.note)
        survey.note = insertDate(survey.note)
    }

    if (Array.isArray(survey?.name))
      survey.name = survey.name[g1] || survey.name[0]

    if (survey?.type === SurveyEnum.boolean && !survey.list)
      survey.list = [
        {"icon": <IconNo/>, "title": t("no")},
        {"icon": <IconYes/>, "title": t("yes")}
      ]

    if (!survey.image?.includes('/static/')) {
      if (survey && surveyList[index]?.type === SurveyEnum.pic) {
        if (window.landing === LandingEnum.adhd) {
          survey.image = getImage('img/survey/face/adhd/img_' + (survey.id || survey.title).toLowerCase().replace(/ /g, '_').replace(/\./g, '') + '.svg')
        } else {
          let lng = survey.lng || i18n.resolvedLanguage

          if (
            // goalId === 'singing' ||
            ['ru', 'uk', 'es'].includes(i18n.resolvedLanguage)
          )
            lng = 'en'
          // else if (survey.A33) { // FIXME: Для es проверим новые паки селеб в будущем
          //   survey.id = survey.A33.id
          //   survey.title = survey.A33.title
          // }

          survey.image = getImage(`i18/${lng}/img/survey/face/` + (survey.id || survey.title).toLowerCase().replace(/ /g, '_').replace(/\./g, '') + '.png')

          // if (isExistImage(image))
          //   survey.image = getImage(image)
          // else {
          //   isLocale = !isLocale
          //   survey.image = getImage(`i18/${isLocale ? i18n.resolvedLanguage : 'en'}/img/survey/face/` + (survey.id || survey.title).toLowerCase().replace(/ /g, '_').replace(/\./g, '') + '.png')
          // }
        }
      } else if (survey?.image)
        survey.image = getImage('img/survey/' + survey.image.replace('{sex}', sex))
    }

    if (
      [LandingEnum.adhd, LandingEnum.dating, LandingEnum.interview, LandingEnum.voiceage, LandingEnum.smalltalk].includes(window.landing) &&
      survey?.id === 'communication-style'
    ) {
      try {
        const
          surList = surveyList.find(({id}) => id === 'describe-voice'),
          sur = surList.switch?.find(({targetIndex}) => targetIndex === g1) || surList.switch?.[0] || surList,
          s11 = surveyList.findIndex(({id}) => id === 'describe-voice'),
          g11 = state.resultList?.[s11]?.[0],
          communication_style_txt = sur?.list?.[g11]?.title

        if (communication_style_txt)
          survey.rive.texts = {communication_style_txt}
      } catch (ex) {
        console.error('catched', ex)
      }
    }


    if (survey?.rive) {
      if (survey.rive.image && !survey.rive.image.includes('/static/'))
        survey.rive.image = getImage('img/survey/' + survey.rive.image)

      switch (survey.rive.value) {
        case 'target1':
          survey.rive.value = g1 + 1
          break

        case '{sex_id}':
          survey.rive.value = sexId
          break

        default:
          if (survey.rive.random)
            survey.rive.value = Math.floor(Math.random() * survey.rive.random) + 1

          break
      }

      // if (process.env.REACT_APP_MODULE !== 'default')
      //   survey.rive.src = `/${process.env.REACT_APP_MODULE}/static/rive/${survey.rive.src}`
    }

    if (survey?.items) {
      for (const item of survey.items) {
        if (item.image && !item.image.includes('/static/'))
          item.image = getImage('img/survey/' + item.image)
      }
    }

    if (survey?.list) {
      for (const item of survey.list) {
        if (item.image && !item.image.includes('/static/'))
          item.image = getImage('img/survey/' + item.image)
      }
    }

    if (survey?.type === SurveyEnum.rating)
      survey.list = [
        ...Array.from({ length: 5 - (survey.list?.length || 0) }, (_, i) => ({
          title: (survey.list?.length || 0) + i + 1
        }))
      ]


    return survey
  }

  let
    survey = getSurveyByIndex(state.index),
    surveyNext = getSurveyByIndex(state.index + 1)

  useLayoutEffect(() => {
    if (!step)
      return

    if (state.index && !state.resultList[state.index - 1]) {
      state.index = 0
      setState({...state})
    }
  }, [])

  useLayoutEffect(() => {
    if (!step)
      return

    if (survey) {
      if (isDeleted(survey)) {
        state.resultList[state.index] = []
        state.index++
      } else
        setStep(
          {
            step: state.index + step,
            page: (survey.id || survey.name || survey.description).replace(/<br>|\n/g, ' ') + (surveyList[state.index]?.type === SurveyEnum.pic ? ' - ' + (survey.id || survey.title) : '')
          },
          false
        )

      // if (survey.experiment)
      //   setExperiment(survey.experiment)

      if (state.index !== hash) {
        if (state.index)
          navigate('#' + state.index)
        else
          navigate('')
      }
    }

    if (state.index === 17)
      trackContent(17)
  }, [state.index])
  // }, [state.index, survey])

  useLayoutEffect(() => {
    if (!step)
      return

    if (
      hash !== state.index &&
      // Number.isInteger(hash) && hash < surveyList.length &&
      state.index < surveyList.length - 1 &&
      (state.resultList[hash] || state.resultList[hash - 1])
    ) {
      state.index = hash
      backProcess()
      setState({...state})
    }
  }, [hash])

  const isNextEnable = () => {
    return (
      [SurveyEnum.info, SurveyEnum.infoReverse].includes(survey.type) ||
      state.resultList[state.index]?.length > 0 ||
      survey.optional
    )
  }

  const isNext = () => {
    return (
      survey.multiple || survey.next ||
      [SurveyEnum.line, SurveyEnum.swipe].includes(survey.type) && state.resultList[state.index]?.length > 0 ||
      [SurveyEnum.info, SurveyEnum.infoReverse, SurveyEnum.pic, SurveyEnum.startLine].includes(survey.type)
    )
  }

  function handleNext(force) {
    const
      checkedList = state.resultList[state.index] || [],
      item = survey?.list?.[checkedList[0]],
      itemTitle = item?.id || item?.title,
      surveyId = surveyList[state.index]?.id

    switch (surveyId) {
      case 'target1':
        // mixpanel.track(survey.id, {value: itemTitle})
        // mixpanel.track_pageview({page: survey.id})

        setRegister({user_goal1: itemTitle})
        setProfile({user_goal1: itemTitle})
        trackEvent('1st goal choice', {goal: itemTitle})
        break

      case 'target2':
        const user_goal2 = []

        for (const j of checkedList) {
          let title = survey?.list?.[j]?.id || survey?.list?.[j]?.title

          if (title)
            title = title.replace(/<br>/g, ' ')

          user_goal2.push(title)
        }

        setRegister({user_goal2})
        setProfile({user_goal2})
        trackEvent('2nd goal choice', {goal: user_goal2})
        break
    }

    switch (window.landing) {
      case LandingEnum.charisma:

        switch (surveyId) {
          case 'impression':
          case 'charisma start':
          case 'charisma completed':
          case 'exercise 1':
          case 'exercise 4':
            trackEvent(surveyId, {value: itemTitle})
            break

          case 'objectives':
            const values = []

            for (const j of checkedList)
              values.push(survey?.list?.[j]?.id || survey?.list?.[j]?.title)

            trackEvent(surveyId, {values})
            break
        }

        break

      default:

        switch (surveyId) {
          case 'gender':
            setProfile({gender: itemTitle})
            trackEvent('gender choice', {gender: itemTitle})
            break

          case 'almost':
            trackEvent('almost there')
            break

          case 'native-speaker':
            trackEvent('native speaker', {value: checkedList[0]})
            break

          case 'describe-voice':
            const goal = []

            for (const j of checkedList) {
              let title = survey?.list?.[j]?.id || survey?.list?.[j]?.title

              if (title)
                title = title.replace(/<br>/g, ' ')

              goal.push(title)
            }

            trackEvent('3rd goal choice', {goal})
            break
        }

        break
    }

    if ([SurveyEnum.info, SurveyEnum.infoReverse, SurveyEnum.progress].includes(survey?.type))
      state.resultList[state.index] = [true]
    else if (!state.resultList[state.index])
      state.resultList[state.index] = []

    save()

    state.index++

    // if (A93.value === 'B' && state.index >= surveyList.length - 1) {
    //   state.resultList[state.index + 1] = []
    //   save()
    //   setTrack('section_4_completed')
    //   navigate(getUrl('/check-voice'))
    //   return
    // } else
    if (state.index + 1 >= surveyList.length)
      setTrack('section_4_completed')

    if (state.index >= surveyList.length) {
      navigate(nextUrl)
      return
    }
    // else if (survey.rive && surveyNext?.rive?.inputName) {
    //   //FIXME: fix multiple rive load
    //   console.warn('fixme', state.index)
    //   window.location.href = '/survey#' + state.index;
    //   window.location.reload();
    //   return;
    // }

    // if (surveyList?.[state.index]?.previousOne) {
    //   surveyList[state.index].list = [];
    //
    //   const sorted = state.resultList[state.index - 1].sort();
    //
    //   for (const i of sorted)
    //     surveyList[state.index].list.push(
    //       surveyList[state.index - 1].list[i]
    //     );
    //
    //   if (state.resultList[state.index - 1].length === 1) {
    //     state.resultList[state.index] = [0]; // state.resultList[state.index - 1];
    //     state.index++;
    //   }
    // }

    if (!force)
      setState({...state})
  }

  const handleFillResults = () => {
    while (state.index < surveyList.length) {
      if (!state.resultList[state.index]?.length)
        state.resultList[state.index] = [0]

      handleNext(true)
      survey = getSurveyByIndex(state.index)
    }

    navigate(
      nextUrl
      // A93.value === 'B'
      //   ? getUrl('/check-voice')
      //   : nextUrl
    )
  }

  const save = () => {
    window.localStorage.setItem(
      'survey_results',
      JSON.stringify(state.resultList)
    )
  }

  function handleBack() {
    state.index--
    backProcess()

    if (state.index < 0)
      navigate(getUrl('/'))
    else
      setState({...state})
  }

  const isDeleted = (sur) => {
    if (sur?.deleted)
      return true

    if (sur?.target && sur?.exclude) {
      const si = surveyList.findIndex(item => item.id === sur.target)
      const res = state.resultList[si]

      if (sur.exclude.includes(res[0]))
        return true
    }

    return false
  }

  const backProcess = () => {
    if ([SurveyEnum.info, SurveyEnum.infoReverse].includes(surveyList?.[state.index]?.type))
      state.index--

    // if (surveyList?.[state.index]?.previousOne && state.resultList[state.index].length === 1)
    //   state.index--;

    if (isDeleted(surveyList?.[state.index]))
      state.index--

    // state.resultList = state.resultList.splice(0, state.index);
    save()

    window.timerProgress && clearInterval(window.timerProgress)
  }

  const trackEvent = (action, data) => {
    setTrackStep(
      action,
      {...data, step: state.index + step},
      false
    )
  }

  function handleChange(checkedList) {
    // console.log('handleChange', checkedList)

    if (state.resultList[state.index]) {
      const every = checkedList.every(r => state.resultList[state.index].includes(r))

      if (!every || state.resultList[state.index].length !== checkedList.length) {
        for (let i = state.index + 1; i < surveyList.length; i++) {
          const sur = surveyList[i];

          // if (state.resultList[i] && (sur.switch || sur.previousOne)) {
          if (state.resultList[i] && sur.switch) {
            const sIndex =
              sur.target
                ? surveyList.findIndex(item => item.id === sur.target)
                : i - 1;

            if (sIndex === state.index)
              state.resultList[i] = [];
          }
        }
      }
    }

    state.resultList[state.index] = checkedList
    setState({...state})
    save()

    if (
      !survey.multiple && !survey.next && ![SurveyEnum.line, SurveyEnum.swipe].includes(survey.type) ||
      survey.type === SurveyEnum.boolean
    )
      upTimer(() => handleNext(), survey.timeout)
  }

  function getResults() {
    const results = []

    try {
      const s1 = surveyList.findIndex(({id}) => id === 'target1')
      let g1 =
        window.landing.includes('masculinity')
          ? surveyList[s1].list.findIndex(({id, title}) => id === 'Masculinity' || title === 'Masculinity')
          : +state.resultList?.[s1]?.[0] || 0

      state.resultList.map((resList, i) => {
        let survey = getSurveyByIndex(i)

        if (!survey) {
          console.error('no survey')
          return true
        }

        if (surveyList[i]?.type === SurveyEnum.pic && !survey?.id)
          survey.id = survey.title.replace(/ /g, '-')

        if (
          [SurveyEnum.info, SurveyEnum.infoReverse, SurveyEnum.progress].includes(surveyList[i]?.type || survey.type)
        )
          return true

        const list = []

        for (const j of resList || []) {
          let title = survey.list?.[j]?.title || surveyList[i]?.id

          if (title) {
            if (Array.isArray(title))
              title = title[g1] || title[0]

            title = title.toString().replace(/<br>/g, ' ')
          }

          list.push(title)
        }

        results.push({id: survey.id, name: survey.name, title: survey.title, list})

        return true
      })

    } catch (ex) {
      console.error(ex)

      if (process.env.REACT_APP_DEBUG)
        throw new Error(ex)
    }

    return results
  }



  // preload images
  if (!step) {
    let surList

    if (surveyNext)
      surList = [surveyNext]
    else
      surList = surveyList[state.index + 1]?.switch || []

    for (const sur of surList) {
      if (
        sur?.image && !sur.rive &&
        (!window.imageList || !window.imageList.includes(sur.image))
      ) {
        const img = new Image()
        img.src = sur.image

        if (!window.imageList)
          window.imageList = []

        window.imageList.push(sur.image)
      }
    }
  }

  return {
    state, setState, g1, goal, goalId, resGender,
    surveyList,
    getSurveyByIndex,
    survey, surveyNext,
    isNext, isNextEnable, handleNext,
    handleBack,
    handleChange,
    handleFillResults,
    getResults,
  }
}